import React from "react";
import s from "./App.module.css";
import HW5 from "../s2-homeworks/hw05/HW5";

function App() {
  return (
    <div className={s.App}>
      <HW5 />
    </div>
  );
}

export default App;
